<template>
  <div class="uk-container uk-margin-medium" :key="key">
    <div uk-grid>
      <div class="uk-width-1-4">
        <div
          class="uk-card uk-card-default uk-card-body uk-width-1- uk-card-small"
        >
          <h3 class="uk-margin-small-bottom">
            Project ID: {{ projectData.projectID }}
          </h3>
          <div
            v-if="!emailEditable"
            class="uk-inline uk-width-1-1 uk-margin-small"
            @click="editProjectEmail"
          >
            <span
              class="uk-form-icon uk-form-icon-flip"
              uk-icon="icon: pencil"
            ></span>
            <input v-model="projectData.email" class="uk-input" disabled />
          </div>
          <div v-if="emailEditable">
            <input v-model="editedEmail" class="uk-input" />
            <button
              class="uk-button uk-button-default uk-margin-small-top uk-width-1-1"
              @click="saveProjectEmail"
            >
              Save Email
            </button>
          </div>
          <router-link :to="'/project/' + projectData.projectID"
            >Customer View</router-link
          >
          <admin-upload
            v-bind:firebaseID="firebaseID"
            :projectData="projectData"
            @files-uploaded="filesUploaded"
            @increment-proof-count="incrementProofCount"
          ></admin-upload>
          <button
            class="uk-button uk-button-default uk-width-1-1"
            v-if="!preDelete"
            @click="preDelete = true"
          >
            Delete Project
          </button>
          <button
            class="uk-button uk-button-danger uk-width-1-1"
            v-if="preDelete && !projectDeleted"
            @click="deleteProject"
          >
            Really Delete?
          </button>
          <button
            class="uk-button uk-button-secondary uk-width-1-1"
            v-if="preDelete && projectDeleted"
            @click="deleteProject"
          >
            Project Deleted!
          </button>
        </div>
      </div>
      <div class="uk-width-3-4">
        <div class="uk-child-width-1-3@m uk-grid uk-grid-match" uk-grid>
          <div class="uk-width-1-1">
            <div class="uk-card uk-card-default uk-card-body uk-card-small">
              <h3>Project Settings</h3>
              <div class="uk-margin">
                <label class="uk-form-label" for="form-horizontal-text"
                  >Set-Up Charge (e.g. 20)</label
                >
                <div class="uk-form-controls">
                  <input
                    class="uk-input"
                    id="form-horizontal-text"
                    type="text"
                    v-model="projectData.setupCharge"
                  />
                </div>
              </div>
              <div class="uk-margin">
                <label class="uk-form-label" for="form-horizontal-select"
                  >Project Type</label
                >
                <div class="uk-form-controls">
                  <select
                    class="uk-select"
                    id="form-horizontal-select"
                    v-model="projectData.type"
                  >
                    <option>Organization</option>
                    <option>Distributor</option>
                    <option>Wedding</option>
                    <option>Individual</option>
                  </select>
                </div>
              </div>
              <div uk-grid class="uk-grid">
                <div class="uk-width-1-2">
                  <div class="uk-margin">
                    <label class="uk-form-label" for="form-horizontal-text"
                      >Price Adjustment Label</label
                    >
                    <div class="uk-form-controls">
                      <input
                        class="uk-input"
                        id="form-horizontal-text"
                        type="text"
                        v-model="projectData.priceAdjustment.label"
                      />
                    </div>
                  </div>
                </div>
                <div class="uk-width-1-2">
                  <div class="uk-margin">
                    <label class="uk-form-label" for="form-horizontal-text"
                      >Price Adjustment Amount</label
                    >
                    <div class="uk-form-controls">
                      <input
                        class="uk-input"
                        id="form-horizontal-text"
                        type="text"
                        v-model="projectData.priceAdjustment.amount"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div uk-grid class="uk-grid">
                <div class="uk-width-1-2">
                  <div class="uk-margin">
                    <label class="uk-form-label" for="form-horizontal-text"
                      >Custom Shipping Label</label
                    >
                    <div class="uk-form-controls">
                      <input
                        class="uk-input"
                        id="form-horizontal-text"
                        type="text"
                        v-model="projectData.customShipping.label"
                      />
                    </div>
                  </div>
                </div>
                <div class="uk-width-1-2">
                  <div class="uk-margin">
                    <label class="uk-form-label" for="form-horizontal-text"
                      >Custom Shipping Amount</label
                    >
                    <div class="uk-form-controls">
                      <input
                        class="uk-input"
                        id="form-horizontal-text"
                        type="text"
                        v-model="projectData.customShipping.amount"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-for="product in products">
            <admin-product
              :product="product"
              :all-products="allProducts"
              :settings="settings"
              @delete-product="deleteProduct"
            ></admin-product>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import UIkit from "uikit";
import firebase from "firebase";
import AdminProduct from "@/components/admin/AdminProduct.vue";
import AdminUpload from "@/components/admin/AdminUpload.vue";
import router from "@/router";

export default {
  name: "ProjectAdmin",
  data() {
    return {
      projectData: {},
      firebaseID: "",
      products: [],
      allProducts: [],
      ready: false,
      key: 0,
      watchProducts: false,
      preDelete: false,
      projectDeleted: false,
      emailEditable: false,
      editedEmail: "",
      settings: {}
    };
  },
  async created() {
    const contentfulData = await this.getContentfulData("cardData");
    this.settings = contentfulData.portalSettingsCollection.items[0];
    this.allProducts = this.settings.productTypesCollection.items;
  },
  methods: {
    getContentfulData: async () => {
      const query = `{
        portalSettingsCollection(limit: 1) {
          items {
            alertsCollection {
              items {
                alertName
                keyword
                alertDescription
              }
            }
            productTypesCollection {
              items {
                productType
              }
            }
          }
        }
      }`;
      const fetchUrl = `https://graphql.contentful.com/content/v1/spaces/${process.env.CONTENTFUL_SPACE_ID}`;
      const fetchOptions = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${process.env.CONTENTFUL_ACCESS_TOKEN}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          query
        })
      };
      try {
        const response = await fetch(fetchUrl, fetchOptions).then(response =>
          response.json()
        );
        return response.data;
      } catch (error) {
        console.log(error);
        throw new Error("Could not receive the data from Contentful!");
      }
    },
    toggleProductChangeForm() {
      if (this.showProductChangeForm) {
        this.showProductChangeForm = false;
      } else {
        this.showProductChangeForm = true;
      }
    },
    updateFirebaseProducts() {
      // Set the "capital" field of the city 'DC'
      for (let index = 0; index < this.products.length; index++) {
        const product = this.products[index];
        console.log(product);
        var productsRef = firebase
          .firestore()
          .collection("projects")
          .doc(this.firebaseID)
          .collection("products");
        productsRef
          .doc(product.productId)
          .update(product.productData)
          .then(function() {
            console.log("Document successfully updated!");
          })
          .catch(function(error) {
            // The document probably doesn't exist.
            console.error("Error updating document: ", error);
          });
      }
    },
    updateFirebaseProject() {
      var self = this;
      var projectRef = firebase
        .firestore()
        .collection("projects")
        .doc(self.firebaseID);

      projectRef
        .update(self.projectData)
        .then(function() {
          console.log("Document successfully updated!");
        })
        .catch(function(error) {
          // The document probably doesn't exist.
          console.error("Error updating document: ", error);
        });
    },
    filesUploaded(count) {
      var self = this;
      setTimeout(function() {
        self.getFirebaseProducts();
        self.projectData.proofCount += count;
      }, 2000);
    },
    incrementProofCount(length) {
      this.projectData.proofCount += 1;
      console.log(this.projectData.proofCount);
    },
    deleteProduct(productID) {
      console.log(productID);
      var self = this;
      firebase
        .firestore()
        .collection("projects")
        .doc(self.firebaseID)
        .collection("products")
        .doc(productID)
        .delete()
        .then(function() {
          console.log("Document successfully deleted!");
          self.getFirebaseProducts();
        })
        .catch(function(error) {
          console.error("Error removing document: ", error);
        });
    },
    getFirebaseProducts() {
      var self = this;
      self.watchProducts = false;
      self.products = [];
      firebase
        .firestore()
        .collection("projects")
        .doc(this.firebaseID)
        .collection("products")
        .orderBy("created", "desc")
        .get()
        .then(function(querySnapshot) {
          querySnapshot
            .forEach(function(doc) {
              let product = {
                productId: doc.id,
                productData: doc.data()
              };
              self.products.push(product);
            })
            .then(function() {
              self.watchProducts = true;
            });
          self.ready = true;
        });
    },
    deleteProject() {
      let self = this;
      firebase
        .firestore()
        .collection("projects")
        .doc(this.firebaseID)
        .delete()
        .then(function() {
          self.projectDeleted = true;
          setTimeout(() => {
            router.push({ name: "AdminPortal" });
          }, 500);
        })
        .catch(function(error) {
          console.error("Error removing document: ", error);
        });
    },
    editProjectEmail() {
      this.editedEmail = this.projectData.email;
      this.emailEditable = true;
    },
    saveProjectEmail() {
      this.projectData.email = this.editedEmail;
      this.emailEditable = false;
    }
  },
  watch: {
    firebaseID: function() {
      this.getFirebaseProducts();
    },
    products: {
      deep: true,
      handler(newValue, oldValue) {
        this.updateFirebaseProducts();
      }
    },
    projectData: {
      deep: true,
      handler(newValue, oldValue) {
        if (oldValue) {
          this.updateFirebaseProject();
        }
      }
    }
  },
  mounted: function() {
    var self = this;

    //get project from firestore by project id
    firebase
      .firestore()
      .collection("projects")
      .where("projectID", "==", self.$route.params.id)
      .get()
      .then(function(querySnapshot) {
        querySnapshot.forEach(function(doc) {
          self.projectData = doc.data();
          self.firebaseID = doc.id;
          if (!self.projectData.customShipping) {
            self.projectData.customShipping = Object.assign({
              label: "",
              amount: 0
            });
          }
          doc.ref
            .collection("products")
            .orderBy("created", "desc")
            .get()
            .then(function(querySnapshot) {
              querySnapshot.forEach(function(document) {});
            });
        });
      });
  },
  components: {
    "admin-product": AdminProduct,
    "admin-upload": AdminUpload
  },
  filters: {}
};
</script>

<style type="text/css">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/ProjectAdmin.vue